<template>
  <div class="doubleDeposit">
    <img src="@/assets/images/ad/mianyaBg.png">
  </div>
</template>

<script>
export default {
  name: "doubleDeposit"
}
</script>

<style lang="scss" scoped>
.doubleDeposit {
  width: 100%;
  font-size: 24px;
  img {
    width: 100%;
  }
}
</style>